/**
 * 诊断相关接口
 */

import request from "@/utils/request";

// 获取诊断列表
export function getDiseaseList(data) {
    return request({
        url: "/disease/disease-list",
        method: "post",
        data
    })
}